export default "__VITE_ASSET__Opgxw6_4__"